module.exports = __webpack_public_path__ + "static/media/10397979_910094269011996_1174933051017138398_n.70f4effc.jpg";